<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.tools-solid"></svg-vue>
          <h1 class="content-title">{{ $t('Assigned me repairs') }} ({{ repairList.length }})</h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-purple" to="/workshop">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <div class=" p-4 md:w-2/3 items-center md:flex md:justify-between sm:px-6">
          <!-- component -->
          <input
            type="text"
            id="search"
            v-model.lazy="filters.search"
            :placeholder="$t('Search')"
            @change="getRepairOrders"
            class="form-input rounded-none rounded-l-md"
          />
          <div class="flex relative w-full">
            <select @change="getRepairOrders" id="status" v-model="filters.status" class="form-input rounded-none">
              <option :value="null">{{ $t('By status') }}</option>
              <template v-for="(status, index) in statusList">
                <option :key="index" :value="status.id">
                  {{ status.body }}
                </option>
              </template>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-400">
              <svg class="fill-current h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
              </svg>
            </div>
          </div>
          <div class="flex relative w-full">
            <select @change="getRepairOrders" aria-label="Sort by" class="form-input rounded-none" id="status" v-model="filters.priority">
              <option :value="null">{{ $t('By priority') }}</option>
              <template v-for="(priority, index) in priorityList">
                <option :key="index" :value="priority.id">
                  {{ priority.name }}
                </option>
              </template>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-400">
              <svg class="fill-current h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
              </svg>
            </div>
          </div>
          <div class="flex relative w-full">
            <select @change="changeSort" aria-label="Sort by" class="form-input rounded-none" id="status" v-model="sort.column">
              <option value="name">{{ $t('name') }}</option>
              <option value="email">{{ $t('email') }}</option>
              <option value="id">{{ $t('Order Number') }}</option>
              <option value="created_at">{{ $t('Created at') }}</option>
              <option value="updated_at">{{ $t('Updated at') }}</option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-400">
              <svg class="fill-current h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
              </svg>
            </div>
          </div>
          <button @click="changeSort" class="flex text-gray-800 rounded-none rounded-r-md font-bold py-2 border border-gray-300 px-6" type="button">
            <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.sort-amount-down-alt-regular" v-show="sort.order === 'asc'"></svg-vue>
            <svg-vue class="h-4 w-4 text-gray-700" icon="font-awesome.sort-amount-up-alt-regular" v-show="sort.order === 'desc'"></svg-vue>
            <span class="ml-2">{{ $t('Sort') }}</span>
          </button>
        </div>
        <template v-if="repairList.length > 0">
          <div class="-my-2 sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <table class="min-w-full divide-y divide-gray-200 hidden sm:block">
                <caption class="hidden">
                  Repair list
                </caption>
                <thead>
                  <tr class="bg-blue-100">
                    <th
                      class="px-6 py-2 text-left text-xs leading-4 font-medium text-gray-900 uppercase tracking-wider whitespace-no-wrap overflow-x-auto"
                      scope="row"
                    >
                      {{ $t('Repair Information') }}
                    </th>
                    <th
                      class="px-6 py-2 text-left text-xs leading-4 font-medium text-gray-900 uppercase tracking-wider whitespace-no-wrap overflow-x-auto"
                      scope="row"
                    >
                      {{ $t('Repair Information') }}
                    </th>
                    <th
                      class="px-6 py-2 text-left text-xs leading-4 font-medium text-gray-900 uppercase tracking-wider whitespace-no-wrap overflow-x-auto
                        "
                      scope="row"
                    >
                      {{ $t('Created at') }}
                    </th>
                    <th
                      class="
                          px-6
                          py-2
                          text-left text-xs
                          leading-4
                          font-medium
                          text-gray-900
                          uppercase
                          tracking-wider
                          whitespace-no-wrap
                          overflow-x-auto
                        "
                      scope="row"
                    >
                      {{ $t('Updated at') }}
                    </th>
                    <th
                      class="
                          px-6
                          py-2
                          text-left text-xs
                          leading-4
                          font-medium
                          text-gray-900
                          uppercase
                          tracking-wider
                          whitespace-no-wrap
                          overflow-x-auto
                        "
                      scope="row"
                    >
                      {{ $t('Status') }}
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-100">
                  <template v-for="(repairOrder, index) in repairList">
                    <router-link
                      :key="index"
                      :to="`/workshop/repairable-list/${repairOrder.uuid}/manage`"
                      class="cursor-pointer hover:bg-gray-100 p"
                      tag="tr"
                    >
                      <td class="px-6 py-4 whitespace-no-wrap leading-5">
                        <div
                          class="
                              w-full
                              truncate
                              text-sm
                              leading-5
                              text-gray-900
                            "
                        >
                          <div class="flex items-center">
                            <div class="flex-shrink-0 h-10 w-10">
                              <img :alt="$t('Avatar')" :src="repairOrder.device.avatar" class="h-10 w-10 rounded-full" />
                            </div>
                            <div class="ml-4">
                              <div
                                class="
                                    text-sm
                                    leading-5
                                    font-medium
                                    text-gray-900
                                  "
                              >
                                <span class="p-1 bg-gray-500 text-sm text-white">{{ repairOrder.brand.name | uppercase }}</span>
                                {{ repairOrder.device.name | capitalize }}
                              </div>
                              <div class="text-sm leading-5 text-gray-700">[{{ repairOrder.device.model }}]</div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 max-w-0 w-full whitespace-no-wrap">
                        <div
                          class="
                              flex
                              text-sm
                              leading-5
                              text-gray-900
                              w-full
                              truncate
                            "
                        >
                          <span class="text-blue-900"> {{ $t('Order') }}: {{ repairOrder.id }} | #{{ repairOrder.tracking }} </span>
                          | {{ $t('Issues') }} : {{ repairOrder.defects }} | {{ $t('Serial number') }}: {{ repairOrder.serial_number }} [{{
                            repairOrder.priority.name
                          }}]
                        </div>
                        <div
                          class="
                              text-sm
                              leading-5
                              text-gray-700
                              w-full
                              truncate
                            "
                        >
                          {{ repairOrder.name }}({{ repairOrder.email }})
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-no-wrap leading-5">
                        <div class="text-sm text-gray-800">
                          {{ repairOrder.created_at | momentFormatDate }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-no-wrap leading-5">
                        <div class="text-sm text-gray-800">
                          {{ repairOrder.updated_at | momentFormatDateTimeAgo }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-no-wrap leading-5">
                        <div
                          class="
                              text-sm text-gray-800
                              bg-blue-100
                              px-2
                              text-center
                              rounded-md
                              border
                            "
                        >
                          {{ repairOrder.status.body }}
                        </div>
                      </td>
                    </router-link>
                  </template>
                </tbody>
              </table>
              <div class="sm:hidden">
                <ul>
                  <template v-for="(repairOrder, index) in repairList">
                    <li :class="{ 'border-t border-gray-200': index !== 0 }" :key="index">
                      <router-link
                        :to="`/workshop/repairable-list/${repairOrder.uuid}/manage`"
                        class="
                            block
                            hover:bg-gray-100
                            focus:outline-none
                            focus:bg-gray-100
                            transition
                            duration-150
                            ease-in-out
                          "
                      >
                        <div class="flex items-center px-4 py-4 sm:px-6">
                          <div class="min-w-0 flex-1 flex items-center">
                            <div class="flex-shrink-0 text-gray-700">
                              <img :alt="$t('Avatar')" :src="repairOrder.device.avatar" class="h-10 w-10 rounded-full" />
                            </div>
                            <div class="min-w-0 px-4">
                              <div
                                class="
                                    text-sm
                                    leading-5
                                    text-gray-900
                                    w-full
                                    truncate
                                  "
                              >
                                <span class="text-blue-900"> {{ $t('Order') }}: {{ repairOrder.id }} | #{{ repairOrder.tracking }} </span>
                                <br />
                                | {{ $t('Issues') }} :
                                {{ repairOrder.defects }}
                                <br />
                                {{ $t('Serial number') }} :
                                {{ repairOrder.serial_number }}
                                <br />
                                [{{ repairOrder.priority.name }}]
                              </div>
                            </div>
                          </div>
                          <div>
                            <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.angle-right-regular"></svg-vue>
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="!loading">
          <div class="h-full flex">
            <div class="m-auto">
              <div
                class="
                    grid grid-cols-1
                    justify-items-center
                    h-full
                    w-full
                    py-24
                  "
              >
                <div class="flex justify-center items-center">
                  <svg-vue class="h-full h-auto w-48 mb-6" icon="undraw.task-list"></svg-vue>
                </div>
                <div class="flex justify-center items-center">
                  <div class="w-full font-semibold text-2xl">
                    {{ $t('No records found') }}
                  </div>
                </div>
                <template v-if="anyFilter">
                  <div class="flex justify-center items-center">
                    <div>{{ $t('Try changing the filters, or rephrasing your search') }}.</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
        <nav
          class="
              bg-white
              px-4
              py-3
              flex
              items-center
              justify-between
              border-t border-gray-200
              sm:px-6
            "
        >
          <div class="hidden sm:block">
            <p class="text-sm leading-5 text-gray-700">
              {{ $t('Showing') }}
              <span class="font-medium">{{ pagination.perPage * pagination.currentPage - pagination.perPage + 1 }}</span>
              {{ $t('to') }}
              <span class="font-medium">{{
                pagination.perPage * pagination.currentPage <= pagination.total ? pagination.perPage * pagination.currentPage : pagination.total
              }}</span>
              {{ $t('of') }}
              <span class="font-medium">{{ pagination.total }}</span>
              {{ $t('results') }}
            </p>
          </div>
          <div class="flex-1 flex justify-between sm:justify-end">
            <button
              :class="pagination.currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
              :disabled="pagination.currentPage <= 1"
              @click="changePage(pagination.currentPage - 1)"
              class="pagination-link"
              type="button"
            >
              {{ $t('Previous') }}
            </button>
            <button
              :class="pagination.currentPage >= pagination.totalPages ? 'opacity-50 cursor-not-allowed' : ''"
              :disabled="pagination.currentPage >= pagination.totalPages"
              @click="changePage(pagination.currentPage + 1)"
              class="ml-3 pagination-link"
              type="button"
            >
              {{ $t('Next') }}
            </button>
          </div>
        </nav>
      </div>
    </div>
  </main>
</template>
<script>
import { pickBy, identity } from 'lodash';

export default {
  name: 'list',
  metaInfo() {
    return {
      title: this.$i18n.t('Assigned me repairs'),
    };
  },
  mounted() {
    this.getFilters();
    this.getRepairOrders();
  },
  data() {
    return {
      loading: true,
      repairList: [],
      statusList: [],
      priorityList: [],
      filters: {
        search: '',
        status: null,
        priority: null,
      },
      sort: {
        order: 'desc',
        column: 'updated_at',
      },
      page: 1,
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  computed: {
    anyFilter() {
      return pickBy(this.filters, identity);
    },
  },
  filters: {
    momentFormatDate(value) {
      return moment(value)
        .locale(window.app.app_date_locale)
        .format(window.app.app_date_format);
    },
    momentFormatDateTimeAgo(value) {
      return moment(value)
        .locale(window.app.app_date_locale)
        .fromNow();
    },
  },
  methods: {
    getFilters() {
      axios.get(route('repair-orders.filters')).then((response) => {
        this.statusList = response.data.statuses;
        this.priorityList = response.data.priorities;
      });
    },
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getRepairOrders();
      }
    },
    changeSort() {
      if (this.sort.order === 'asc') {
        this.sort.order = 'desc';
      } else if (this.sort.order === 'desc') {
        this.sort.order = 'asc';
      }
      this.getRepairOrders();
    },
    getRepairOrders() {
      this.loading = true;
      axios
        .get(route('repair-orders.index'), {
          params: {
            page: this.page,
            sort: this.sort,
            perPage: this.perPage,
            ...this.filters,
          },
        })
        .then((response) => {
          this.repairList = response.data.items;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getRepairOrders();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
